var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 6.8791665 6.8791666",
    id: "svg193",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs190"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.250914,
      fill: "none",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "M 0.52916666,6.3499999 1.0583333,4.2333333",
    id: "path1025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    style: {
      opacity: 1,
      fill: "#cfcfcf",
      stroke: "none",
      strokeWidth: 0.264583,
      fillOpacity: 1
    },
    d: "M 5.0270832 0.26458333 L 4.6302083 0.66145832 L 6.2177082 2.2489583 L 6.6145832 1.8520833 L 6.6145832 1.3229166 L 5.5562499 0.26458333 L 5.0270832 0.26458333 z M 4.3656249 0.92604165 L 1.3229166 3.9687499 L 2.9104166 5.5562499 L 5.9531249 2.5135416 L 4.3656249 0.92604165 z M 1.0583333 4.2333333 L 0.26458333 6.6145832 L 2.6458333 5.8208332 L 1.0583333 4.2333333 z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cfcfcf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "M 2.6458333,6.6145832 V 6.3499999 h 3.4395833 v 0.2645833 z",
    id: "path1441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.189081b2b5413f36e648d2ccb431a59a.svg";
export { ForwardRef as ReactComponent };